module.exports = __webpack_public_path__ + "img/takeasmnt.15d6a012.svg";